module.exports = __webpack_public_path__ + "img/priestj.90abf8bb.jpg";